module.exports = __webpack_public_path__ + "static/product-list-3b6e452c5040cc3cca1fa95ab79d6bf2.png";